import axios from 'axios'

export const createSubscription = async (payload) => {  
  return await axios.post('api/subscription', payload)
}



